import styles from "./style.module.scss";

import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { forwardRef, useEffect, useRef, useState } from "react";
import ExpenseReportFormConfig from "./form";
import { Button, Col, Row } from "reactstrap";
import { getMonthBoundaries } from "@utils/Utils";
import { ExpenseReportFormDataType } from "@/formTypes/ExpenseReportFormDataType";
import { REPORT_EXCEL_FORMAT, REPORT_PRINT_FORMAT } from "@utils/Constants";

type ExpenseReportFormProps = {
}

const ExpenseReportForm = forwardRef<DynamicFormRef, ExpenseReportFormProps>(
  (props, ref) => {
    const formRef = useRef<DynamicFormRef>(null);

    useEffect(() => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      formRef.current?.resetFormValue({
        month,
        year
      })
    }, [])

    const getFormConfig = () => {
      return ExpenseReportFormConfig;
    }

    const generateForm = (formData: ExpenseReportFormDataType) => {
      const { startDate, endDate } = getMonthBoundaries(`${formData.year}`, `${formData.month}`, false)
      if (formData.format == REPORT_PRINT_FORMAT) {
        window.open(`/user/reports/print/expenseByMonth/${startDate}/${endDate}`, "_blank")
      } else if (formData.format == REPORT_EXCEL_FORMAT) {
        window.open(`/user/reports/excel/expenseByMonth/${startDate}/${endDate}`, "_blank")
      }
    }

    return (
      <>
        <DynamicForm<ExpenseReportFormDataType>
          ref={formRef}
          id="report"
          formConfig={getFormConfig()}
          onSubmit={generateForm}
        >
          <Row>
            <Col md={{
              offset: 2
            }}>
              <Button className="me-3" type="submit" color="primary" size="lg">Generar Report</Button>
            </Col>
          </Row>
        </DynamicForm>
      </>
    )
  }
);

export default ExpenseReportForm;